// removed by extract-text-webpack-plugin
module.exports = {"alertContainer":"style__alertContainer___31yC9","alert":"style__alert___fWaA3","showFullText":"style__showFullText___It2QG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/notification/style.scss
// module id = 749
// module chunks = 51